module.exports = __webpack_public_path__ + "img/banner5.36f23e4b.png";